import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';
import { Flag } from '@/modules/authentication/sign-up/components/CountryFlags';
import { SelectCountryIconDropdown } from '@/components/form-inputs/select-country/SelectCountryIconDropdown';
import { ROLE_OPTIONS } from './SingleAddPeopleForm';
import { TextLabelExtraSmall } from '@/components/text/Texts';
import { Row } from '@/components/container/Container';
import { People } from '../engine/People';
import { InputController } from '@/components/inputs/InputController';
import DropdownInput from '@/components/inputs/DropdownInput';
import TextInput from '@/components/inputs/TextInput';

interface Props {
	formName: string;
	form: UseFormReturn<People.EmployeeForm>
}

const SingleEditPeopleForm = ({ form, formName }: Props) => {
	return (
		<FormProvider {...form}>
			<form id={formName}>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					<InputController id="FirstName" control={form.control}>
						<TextInput label="First Name*" />
					</InputController>
					<InputController id="LastName" control={form.control}>
						<TextInput label="Last Name*" />
					</InputController>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
					<InputController id="Email" control={form.control}>
						<TextInput label="Email*" type="email" />
					</InputController>
					<InputController id="RoleId" control={form.control}>
						<DropdownInput options={ROLE_OPTIONS} label="Role" />
					</InputController>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
					<InputController id="ReferenceCode" control={form.control}>
						<TextInput label="ID" keyfilter="num" />
					</InputController>

					<Row className="gap-6">
						<Controller
							name={'Country'}
							control={form.control}
							defaultValue={{ name: 'Philippines', code: 'PH', dialCode: '+63' } as Flag}
							render={({ field, fieldState: { error } }) => (
								<SelectCountryIconDropdown
									value={field.value}
									onChange={field.onChange}
									className="max-h-14"
								/>
							)}
						/>
						<InputController id="Phone" control={form.control}>
							<TextInput label="Phone Number" keyfilter="num" />
						</InputController>
					</Row>
				</div>
				<TextLabelExtraSmall className="py-4 text-black" text="Required form labels ends with an *" />
			</form>
		</FormProvider>
	);
};

export default SingleEditPeopleForm;
